module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v("NOT FOUND")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c03698"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 139
// module chunks = 1